module.exports = "https://portperrypedals.ca/_res/img/latcham.4e28421.jpg";